import React from "react";
import { ReactComponent as TickIcon } from "../Assets/tick.svg";
import { ReactComponent as ClearIcon } from "../Assets/clear.svg";
import { ReactComponent as AddIcon } from "../Assets/add.svg";

/* See ../hack.html for explicit references to min-h-1 etc. so tailwindcss watch will generated those styles */

const SurveyFormUnitCsdFeesTable = ({ width, onModalClose }) => {
  const headers = ["CSD Type", "Base Fee", "Unit Fee", "Easement Fee", "Deposit Fee", "Comment"];
  const data = [
    {
      id: 1,
      type: "Standard Unit CSD",
      baseFee: "tick",
      unitFee: "tick",
      easementFee: "tick",
      depositFee: "tick",
      comment: "",
    },
    {
      id: 2,
      type: "Proposed\nUnit Development (PUD)",
      baseFee: "tick",
      unitFee: "tick",
      easementFee: "tick",
      depositFee: "tick",
      comment: "Unit fee payable for each unit identified on the PUD",
    },
    {
      id: 3,
      type: "Substituted Proposed\nUnit Development (SPUD)",
      baseFee: "tick",
      unitFee: "add",
      easementFee: "add",
      depositFee: "tick",
      comment: "Unit fee payable for each New and/or Changed Unit",
    },
    {
      id: 4,
      type: "First Stage\n(Must be lodged with PUD)",
      baseFee: "tick",
      unitFee: "clear",
      easementFee: "add",
      depositFee: "tick",
      comment: "Easement fee payable for each New and/or Changed Easement",
    },
    {
      id: 5,
      type: "Second and Subsequent Stages,\nComplete or Unit Plan in Substitution.",
      baseFee: "tick",
      unitFee: "clear",
      easementFee: "add",
      depositFee: "tick",
      comment: "Easement fee payable for each New and/or Changed Easement",
    },
    {
      id: 6,
      type: "Redevelopment CSD",
      baseFee: "tick",
      unitFee: "add",
      easementFee: "add",
      depositFee: "tick",
      comment: "Unit fee payable for each New and/or Changed Unit. Easement fee payable for each New and/or changed easement",
    },
  ];

  const Icon = ({ name }) => {
    const icons = {
      tick: (
        <TickIcon className="ml-1 w-5" />
      ),
      add: (
        <AddIcon className="w-8 fill-lui-info" />
      ),
      clear: (
        <ClearIcon className="w-8 fill-lui-error" />
      ),
    }

    return icons[name];
  };

  return (
    <div
      className="print:mt-4"
      style={{maxWidth: width + 'px'}}
    >
      <h2
        className="flex flex-row items-start"
      >
        <ul
          className="flex flex-col text-sm flex-1"
        >
          <li
            className="min-h-6"
          >
            <TickIcon className="mx-1 mr-2 w-5 inline" /> Include this Item Type if appropriate
          </li>
          <li
            className="min-h-6"
          >
            <ClearIcon className="mx-1 w-6 inline fill-lui-error" /> Do not include this Item Type
          </li>
          <li
            className="min-h-6"
          >
            <AddIcon className="mx-1 w-6 inline fill-lui-info" /> Include this where appropriate
          </li>
        </ul>
        <button
          className="py-2 px-4 bg-red-500 text-white rounded mr-4 print:hidden"
          onClick={onModalClose}
        >
          Close
        </button>
      </h2>
      <div className="max-w-fit mx-auto bg-white shadow-lg rounded-lg overflow-hidden print:shadow-none print:rounded-none print:overflow-visible">
        <div className="overflow-x-auto print:overflow-x-visible">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                {headers.map((header, index) => (
                  <th
                    key={index}
                    className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {data.map((row) => (
                <tr key={row.id} className="hover:bg-lui-hint">
                  <td className="px-6 py-4 whitespace-pre-line text-sm font-medium min-w-80 text-gray-900 ">
                    {row.type}
                  </td>
                  <td className="px-6 py-4 text-center">
                    <Icon name={row.baseFee} />
                  </td>
                  <td className="px-6 py-4 text-center">
                    <Icon name={row.unitFee} />
                  </td>
                  <td className="px-6 py-4 text-center">
                    <Icon name={row.easementFee} />
                  </td>
                  <td className="px-6 py-4 text-center">
                    <Icon name={row.depositFee} />
                  </td>
                  <td className="px-6 py-4 whitespace-pre-line text-sm min-w-80">
                    {row.comment}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SurveyFormUnitCsdFeesTable;
